export enum FormMode {
  Create,
  Update
}